import { toast } from "sonner";

const pendingCounts = new Map<string, number>();

export const withLoadingToast = (message: string, id = message) => ({
    onMutate: () => {
        pendingCounts.set(id, (pendingCounts.get(id) ?? 0) + 1);
        toast.loading(message, { id });
    },
    onSettled: () => {
        const count = (pendingCounts.get(id) ?? 1) - 1;
        if (count > 0) {
            pendingCounts.set(id, count);
        } else {
            pendingCounts.delete(id);
            toast.dismiss(id);
        }
    },
});
